import EA from 'helpers/init';
import lightGallery from 'lightgallery';

import 'lightgallery/css/lightgallery.css';

export default EA.Methods.lightgallery = ($this) => {
    const gallery = document.getElementById('gallery');
    const licenseKey = '';

    lightGallery(gallery, {
        selector: '.gallery-src',
        licenseKey: licenseKey,
        speed: 500,
    });
};
